/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Number of guests entity
 * @export
 * @interface TravelineBookingGuestCountDto
 */
export interface TravelineBookingGuestCountDto {
    /**
     * Number of adults
     * @type {number}
     * @memberof TravelineBookingGuestCountDto
     */
    adultCount: number;
    /**
     * Child age range
     * @type {Array<number>}
     * @memberof TravelineBookingGuestCountDto
     */
    childAges?: Array<number> | null;
}

/**
 * Check if a given object implements the TravelineBookingGuestCountDto interface.
 */
export function instanceOfTravelineBookingGuestCountDto(value: object): value is TravelineBookingGuestCountDto {
    if (!('adultCount' in value) || value['adultCount'] === undefined) return false;
    return true;
}

export function TravelineBookingGuestCountDtoFromJSON(json: any): TravelineBookingGuestCountDto {
    return TravelineBookingGuestCountDtoFromJSONTyped(json, false);
}

export function TravelineBookingGuestCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingGuestCountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'adultCount': json['adultCount'],
        'childAges': json['childAges'] == null ? undefined : json['childAges'],
    };
}

  export function TravelineBookingGuestCountDtoToJSON(json: any): TravelineBookingGuestCountDto {
      return TravelineBookingGuestCountDtoToJSONTyped(json, false);
  }

  export function TravelineBookingGuestCountDtoToJSONTyped(value?: TravelineBookingGuestCountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adultCount': value['adultCount'],
        'childAges': value['childAges'],
    };
}

